import { mmFetchWithResponse } from './mmFetchWithResponse';

class FBMOrderIngestResultsEndpoint {
    constructor() {
        this.baseUrl = 'api/fbm/v1/ingestResults';
    }

    /**
     * Get the order ingest results for a given FBM account
     * @param {string} fbmAccountName - The FBM account name
     * @param {number} page - The page number
     * @param {number} pageSize - The page size
     * @param {string} [q] - Search by FBM order number
     * @param {string[]} [types] - Ingest result types to include (comma-separated on wire)
     * @returns {Promise<Object>} The order ingest results
     */
    async getOrderIngestResults(fbmAccountName, page, pageSize, q = undefined, types = undefined) {
        let url = `${this.baseUrl}?fbmAccount=${fbmAccountName}&page=${page}&pageSize=${pageSize}`;
        if (q) {
            url += `&q=${encodeURIComponent(q)}`;
        }
        if (types?.length) {
            url += `&types=${encodeURIComponent(types.join(','))}`;
        }
        return mmFetchWithResponse(url, { method: 'GET' });
    }
}

export { FBMOrderIngestResultsEndpoint };
